import React from 'react'
import { PropTypes } from 'prop-types'

import {
  Modal, ButtonGroupWrapper, ButtonGroupPrimary, FilledButton, OutlinedButton, ModalHeading
} from '@jsluna/react'

const RejectPassModal = (props) => {
  const {
    open,
    yesClicked,
    noClicked,
  } = props

  return (
    <Modal fullScreen alert restrictClose open={open}>
      <div className="ln-u-padding-top*3">
        <ModalHeading element="h3">Reject work</ModalHeading>
        <p>Are you sure you want to reject this work and mark all associated passes as rejected?</p>
        <ButtonGroupWrapper actionBar>
          <ButtonGroupPrimary>
            <FilledButton onClick={yesClicked}>Yes, reject work</FilledButton>
            <OutlinedButton onClick={noClicked}>{'No, don\'t reject work'}</OutlinedButton>
          </ButtonGroupPrimary>
        </ButtonGroupWrapper>
      </div>
    </Modal>
  )
}

RejectPassModal.propTypes = {
  open: PropTypes.bool.isRequired,
  yesClicked: PropTypes.func.isRequired,
  noClicked: PropTypes.func.isRequired
}

export default RejectPassModal



// WEBPACK FOOTER //
// ./src/components/Passes/PassDetails/RejectPassModal.jsx